module.exports = __webpack_public_path__ + "static/routineCreation-1516ad6dda1d825536ee61bad8e0d2e1.png";